import { format } from 'd3-format';
import { utcParse } from "d3-time-format";
import moment from 'moment';
import React, { Component } from 'react';
import { Digital } from 'react-activity';
import "react-activity/dist/Digital.css";
import Popup from "reactjs-popup";
import './App.css';
import { flags } from './asset/image/flags';
import { ChartButton } from './components/ChartButton';
import { IncomeView } from './components/IncomeView';
import OSSNotice from './components/OSSNotice';
import { ResultScene } from './components/ResultScene';
import TGChart from './components/TGChart';
import { chartOption } from './global/ChartOption';
import { getStoreBadge } from './global/Common';
import { companyInfo } from './global/CompanyInfo';
import { exchangeValue } from './global/Currency';
import i18next from './global/LocalizedStrings';
import { THEME } from './global/Theme';
import { initTradeInfo, tradeInfo } from './global/TradeInfo';
import { getData } from './utils/utils';


class Home extends Component {

    constructor(props) {
        super(props);
        this.onClickChartButton = this.onClickChartButton.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.changeLang = this.changeLang.bind(this)

        this.state = {
            theme: THEME.LIGHT,
            showResult: false,
            showOSSNotice: false,
            progress: true
        }
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount() {

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        getData().then((data) => {

            data.info.exchange = JSON.parse(data.info.exchange)
            data.info.industry = JSON.parse(data.info.industry)
            data.info.name = JSON.parse(data.info.name)
            data.info.sector = JSON.parse(data.info.sector)

            const trade_info = initTradeInfo(100000, 100000);
            this.companyInfo = Object.assign(data.info, companyInfo)
            trade_info.stockCurrency = data.info.currency
            trade_info.view_type = 'GAME'
            trade_info.exchangeValue = exchangeValue
            const chartData = {
                chartOption,
                trade_info,
                language: i18next.language,
                data: data.price,
            }
            this.loadChart(chartData)
        })


    }

    loadChart(chartData) {

        const { chartOption, trade_info, language, data, companyCountry } = chartData

        data.forEach(function (d) {
            // d.date = parseDate(d.d)
            d.date = new Date(d.d * 1000)
            d.open = +d.o;
            d.high = +d.h;
            d.low = +d.l;
            d.close = +d.c;
            d.volume = +d.v;
        })

        this.language = language
        this.data = data;
        this.companyCountry = companyCountry;

        this.tradeInfo = Object.assign(trade_info, tradeInfo)
        this.length = 250;

        this.tradeInfo = this.tradeInfo.init(data[0], data[data.length - 1], data[this.length - 1])
        this.tradeInfo.remain = data.length - this.length
        const showData = this.tradeInfo.isGameData() ? this.data.slice(0, this.length) : this.data;

        this.setState({
            length: this.length,
            data: showData,
            chartOption,
            tradeInfo: this.tradeInfo,
            progress: false
        })
    }


    buy(shareCount) {
        const stockData = this.data[this.length - 1]
        this.tradeInfo.deal("BUY", stockData, this.length - 1, shareCount)
        this.moveOneDay()
    }

    sell() {
        const stockData = this.data[this.length - 1]
        this.tradeInfo.deal("SELL", stockData, this.length - 1)
        this.moveOneDay()
    }

    short(shareCount) {
        const stockData = this.data[this.length - 1]
        this.tradeInfo.deal("SHORT", stockData, this.length - 1, shareCount)
        this.moveOneDay()
    }

    exit() {
        const stockData = this.data[this.length - 1]
        this.tradeInfo.deal("EXIT", stockData, this.length - 1)
        this.moveOneDay()
    }

    changeLang(lang) {
        i18next.changeLanguage(lang, (err) => {
            if (err) return console.log('something went wrong loading', err);
            this.setState({})
            moment.locale(i18next.language);
        });
    }

    render() {

        const { theme } = this.state
        const oppTheme = theme.themeName === "LIGHT" ? "DARK" : "LIGHT"
        const dealState = this.tradeInfo ? this.tradeInfo.personDealInfo.state : 'NONE';
        const sellTitle = dealState === 'NONE' ? 'NONE' : (dealState === 'BUY' ? 'sell' : 'corver')

        return (
            <div className="App" >
                <header className="App-header" style={{ backgroundColor: theme.backgroundColor }}>
                    <p className="App-title" style={{ color: theme.textColor }}>
                        TRADERS
                    </p>
                    <span style={{ color: theme.textSecondaryColor }}>Person vs Monkey</span>
                    <span style={{ marginTop: '2vmin', color: theme.textColor }}>{i18next.t('desc')}</span>
                    <span style={{ color: theme.textColor }}>{i18next.t('desc2')}</span>


                    <div>
                        {getStoreBadge(theme, this.state.width)}
                    </div>

                    {this.state.data != null ?
                        <div className="Chart-container">
                            <div className='App-text' style={{ margin: '1em', display: 'flex', justifyContent: 'space-between' }}>
                                <div className="App-theme-button" style={{ alignItems: 'center', backgroundColor: theme.cardBgColor, color: theme.textColor, borderColor: theme.lineColor }} onClick={() => { this.setState({ theme: THEME[oppTheme] }) }}>{oppTheme}</div>
                                <div style={{ textAlign: 'center', color: theme.textColor, position: 'relative', top: 0, left: 0, width: '100%', height: '100%' }}>
                                    {i18next.t('remain', { remain: (this.data.length - this.length) + 1 })}
                                </div>
                            </div>

                            <TGChart
                                data={this.state.data}
                                chartOption={this.state.chartOption}
                                capture={false}
                                language={this.language}
                                tradeInfo={this.tradeInfo}
                                theme={theme}
                            />

                            {
                                this.state.width <= 420 ? (
                                    <div style={{ flex: 2 }}>
                                        <IncomeView tradeInfo={this.tradeInfo} theme={theme} />
                                    </div>
                                ) : null
                            }

                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                {
                                    this.state.width > 420 ? (
                                        <div style={{ flex: 2 }}>
                                            <IncomeView tradeInfo={this.tradeInfo} theme={theme} />
                                        </div>
                                    ) : null
                                }

                                {
                                    sellTitle === 'NONE' ? (
                                        <div style={{ display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'space-around' }}>
                                            <ChartButton onClick={this.onClickChartButton} theme={theme} title={'buy'} />
                                            <ChartButton onClick={this.onClickChartButton} theme={theme} title={'short'} />
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'center' }}>
                                            <ChartButton onClick={this.onClickChartButton} theme={theme} title={sellTitle} />
                                        </div>
                                    )
                                }

                                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    <ChartButton onClick={this.onClickChartButton} theme={theme} title={'move'} />
                                </div>

                                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    {
                                        this.tradeInfo.isMoving ? (
                                            <ChartButton onClick={this.onClickChartButton} theme={theme} title={'stop'} />
                                        ) : (
                                            <ChartButton onClick={this.onClickChartButton} theme={theme} title={'fast'} />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        : null}
                    <Popup
                        contentStyle={{ width: 'calc(100% - 32px)', maxWidth: '800px', backgroundColor: theme.backgroundColor, padding: 0 }}
                        open={this.state.showResult}
                        closeOnEscape={false}
                        closeOnDocumentClick={false}
                        modal
                    >
                        <ResultScene
                            ref="ResultScene"
                            tradeInfo={this.tradeInfo}
                            companyInfo={this.companyInfo}
                            theme={theme}
                            width={this.state.width}
                            nextInvest={() => {

                                this.setState({ progress: true, showResult: false })

                                getData().then((data) => {

                                    const trade_info = initTradeInfo(this.tradeInfo.getPersonEndAsset(), this.tradeInfo.getMonkeyEndAsset());

                                    this.companyInfo = Object.assign(data.info, companyInfo)
                                    trade_info.stockCurrency = data.info.currency
                                    const chartData = {
                                        chartOption,
                                        trade_info,
                                        language: i18next.language,
                                        data: data.price,
                                    }

                                    this.loadChart(chartData)
                                })

                            }}
                        />

                    </Popup>

                    <div style={{ position: 'absolute', top: '1em', right: '1em' }}>
                        <Popup
                            trigger={
                                <div >
                                    <img src={flags[i18next.getCountryCode3()]} style={{ cursor: 'pointer', width: '1.5em', height: '1.5em' }} />
                                </div>}
                            contentStyle={{ zIndex: 100, backgroundColor: theme.cardBgColor, borderColor: theme.lineColor }}
                            arrowStyle={{ backgroundColor: theme.cardBgColor, borderColor: theme.lineColor }}
                            position={['bottom left']}>

                            <div style={{ display: 'flex', flexDirection: 'column', }}>

                                <div onClick={() => this.changeLang('en-US')} className='App-lang-button' style={{ color: theme.textColor }}>
                                    <img src={flags.us} style={{ width: '1em', height: '1em', marginRight: '0.3em' }} />
                                    <div>{i18next.t('language.usa')}</div>
                                </div>

                                <div onClick={() => this.changeLang('ko-KR')} className='App-lang-button' style={{ color: theme.textColor }}>
                                    <img src={flags.kr} style={{ width: '1em', height: '1em', marginRight: '0.3em' }} />
                                    <div>{i18next.t('language.kor')}</div>
                                </div>

                                <div onClick={() => this.changeLang('ja-JP')} className='App-lang-button' style={{ color: theme.textColor }}>
                                    <img src={flags.jp} style={{ width: '1em', height: '1em', marginRight: '0.3em' }} />
                                    <div>{i18next.t('language.jpn')}</div>
                                </div>

                            </div>
                        </Popup>

                        <Popup
                            contentStyle={{ width: 'calc(100% - 32px)', maxWidth: '800px', backgroundColor: theme.backgroundColor, padding: 0 }}
                            open={this.state.showOSSNotice}
                            closeOnEscape={true}
                            closeOnDocumentClick={true}
                            modal
                            onClose={() => {
                                this.setState({ showOSSNotice: false })
                            }}
                        >
                            <OSSNotice theme={theme} closeOssNotice={() => { this.setState({ showOSSNotice: false }) }} />

                        </Popup>
                    </div>
                    {this.state.progress ? (
                        <div style={{ display: 'flex', position: 'absolute', width: '100%', height: '100%', zIndex: 200, backgroundColor: '#00000045', alignItems: 'center', justifyContent: 'center' }}>
                            <Digital color={theme.positiveColor} size={'2em'} />
                        </div>
                    ) : null}
                </header>
                <div style={{ height: 1, backgroundColor: theme.lineColor, }} />
                <footer className="App-footer" style={{ backgroundColor: theme.backgroundColor, color: theme.textDisableColor }}>
                    {/* <Link style={{ color: theme.textDisableColor }} to={'/OSSNotice/' + theme.themeName}>OSS Notice</Link> */}
                    <span style={{ color: theme.textDisableColor, cursor: 'pointer' }} onClick={() => { this.setState({ showOSSNotice: true }) }} >OSS Notice</span>
                    <div>Copyright © CAMINO GAMES. All rights reserved.</div>
                </footer>
            </div>
        );
    }

    onClickChartButton(type) {

        if (type === 'buy') {
            const count = this.tradeInfo.getMaxSharesCount(this.data[this.length - 1])
            this.buy(count)
        } else if (type === 'short') {
            const count = this.tradeInfo.getMaxSharesCount(this.data[this.length - 1])
            this.short(count)
        } else if (type === 'move') {
            this.moveOneDay()
        } else if (type === 'fast') {
            this.fastMove()
        } else if (type === 'stop') {
            this.stopFastMove()
        } else if (type === 'sell' || type === 'corver') {
            const dealState = this.tradeInfo ? this.tradeInfo.personDealInfo.state : 'NONE'
            if (dealState === 'BUY') {
                this.sell()
            } else if (dealState === 'SHORT') {
                this.exit()
            }
        }
    }

    moveOneDay() {

        if (this.state.length < this.data.length) {

            this.length += 1;
            const stockData = this.data[this.length - 1]
            this.tradeInfo.calcCurrentAccount(stockData)

            this.tradeInfo.remain = this.data.length - this.length

            this.setState({
                length: this.length,
                data: this.data.slice(0, this.length),
                tradeInfo: this.tradeInfo
            });

        } else {

            const stockData = this.data[this.length - 1]
            this.tradeInfo.calcCurrentAccount(stockData)

            if (this.tradeInfo.isMoving) {
                this.stopFastMove();
                return;
            }


            if (this.tradeInfo.personDealInfo.state === 'BUY' ||
                this.tradeInfo.personDealInfo.state === 'SHORT') {
                this.tradeInfo.endInvestment(this.data[this.data.length - 1], this.length)
            }

            this.setState({
                tradeInfo: this.tradeInfo,
                showResult: true
            });
        }
    }

    fastMove() {
        this.func = () => {
            this.moveOneDay()
        };
        this.tradeInfo.isMoving = true

        if (this.func) {
            if (this.interval) clearInterval(this.interval);
            this.interval = setInterval(this.func, 50);
        }
    }

    stopFastMove() {
        this.tradeInfo.isMoving = false

        this.func = null;
        if (this.interval) clearInterval(this.interval);

        this.moveOneDay();
    }

}


export default Home;
